export default ['velocities', 'displacements', 'power'];
